<template>
  <div class="ig-gallery">
    <div v-if="tags.length > 0" class="ig-gallery-tags">
      <v-chip
        size="small"
        :variant="selectedTag === null ? 'flat' : 'tonal'"
        :color="selectedTag === null ? 'primary' : 'default'"
        class="ig-gallery-tag"
        @click="selectedTag = null"
      >
        همه
      </v-chip>
      <v-chip
        v-for="tag in tags"
        :key="tag"
        size="small"
        :variant="selectedTag === tag ? 'flat' : 'tonal'"
        :color="selectedTag === tag ? 'primary' : 'default'"
        class="ig-gallery-tag"
        @click="selectedTag = tag"
      >
        {{ tag }}
      </v-chip>
    </div>

    <div class="ig-gallery-grid">
      <div
        v-for="(item, idx) in filteredItems"
        :key="item.id"
        class="ig-gallery-item"
        @click="open(idx)"
      >
        <img :src="$store.state.fileBaseUrl + item.image" loading="lazy" alt="" />
        <div v-if="item.image_before" class="ig-compare-badge">
          <v-icon size="13" color="white">mdi-compare-horizontal</v-icon>
        </div>
        <div v-if="item.title" class="ig-caption-overlay">
          <span>{{ item.title }}</span>
        </div>
      </div>
    </div>

    <GalleryLightbox
      v-if="lightboxOpen"
      :items="filteredItems"
      :start-index="activeIndex"
      @close="lightboxOpen = false"
    />
  </div>
</template>

<script>
import GalleryLightbox from './GalleryLightbox.vue';

export default {
  name: 'GalleryGrid',
  components: { GalleryLightbox },
  data: () => ({
    lightboxOpen: false,
    activeIndex: 0,
    selectedTag: null,
  }),
  computed: {
    items() {
      const items = this.$store.state.info.gallery || [];
      return [...items].sort((a, b) => (Number(a.sort_order) || 0) - (Number(b.sort_order) || 0));
    },
    tags() {
      const tags = [];
      this.items.forEach(item => {
        if (item.tag && !tags.includes(item.tag)) tags.push(item.tag);
      });
      return tags;
    },
    filteredItems() {
      if (this.selectedTag === null) return this.items;
      return this.items.filter(item => item.tag === this.selectedTag);
    },
  },
  methods: {
    open(idx) {
      this.activeIndex = idx;
      this.lightboxOpen = true;
    },
  },
};
</script>

<style scoped>
.ig-gallery-tags {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding-bottom: 8px;
  margin-bottom: 6px;
}
.ig-gallery-tags::-webkit-scrollbar { height: 0; }
.ig-gallery-tag {
  cursor: pointer;
  flex-shrink: 0;
}
.ig-gallery-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3px;
}
.ig-gallery-item {
  position: relative;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  cursor: pointer;
  background: rgba(var(--v-theme-on-surface), 0.05);
}
.ig-gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.25s;
}
.ig-gallery-item:hover img { transform: scale(1.06); }

.ig-compare-badge {
  position: absolute;
  top: 6px;
  left: 6px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(0,0,0,0.5);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.ig-caption-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-end;
  padding: 6px;
  background: linear-gradient(to top, rgba(0,0,0,0.55) 0%, transparent 45%);
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: none;
}
.ig-gallery-item:hover .ig-caption-overlay { opacity: 1; }
.ig-caption-overlay span {
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
